import { useStore } from 'effector-react'

import { $orders, $totalCountOfOrders, getOrderList, ordersListMounted, } from './model'
import { OrderRequest } from './types'

export const useOrdersList = () => {
  const onChangeOrdersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: OrderRequest) => {
    ordersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const orders = useStore($orders)
  const totalCountOfOrders = useStore($totalCountOfOrders)
  const loading = useStore(getOrderList.pending)
  return {
    orders,
    totalCountOfOrders,
    loading,
    onChangeOrdersList,
  }
}
